export const LAYOUT = {
    center : 'center',
    left : 'left',
    right : 'right',
}